import createReducer from '../../createReducer';
import {
  FETCH_GRAPH_WEATHER_FORECAST,
  FETCH_GRAPH_WEATHER_FORECAST_SUCCESS,
} from '../../../actions/graphs';

const initialState = {
  utcOffset: null,
  days: null,
  loading: false,
};

const handlers = {};

handlers[FETCH_GRAPH_WEATHER_FORECAST] = () => ({
  ...initialState,
  loading: true,
});

handlers[FETCH_GRAPH_WEATHER_FORECAST_SUCCESS] = (state, { response }) => ({
  utcOffset: response.associated.utcOffset,
  days: response.data.sunlightTimes,
  loading: false,
});

export default createReducer(handlers, initialState);
